export default {"src":"/login-app/[GIT_HASH]/_next/static/media/heart.56b25e61.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};